<template>
  <div>
    <!-- 分配 -->
    <el-dialog :title="$t('message.allocation')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="400px"
      center>
      <div class="allot">
        <el-select v-model="allotVal.y_id" filterable :placeholder="$t('message.salesman')">
          <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="allotVal.p_id" filterable :placeholder="$t('message.distributionMember')">
          <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="allotVal.g_id" filterable :placeholder="$t('message.buyer')">
          <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="adjustOrderAdmin">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    allotVal: { type: Object },
    personnelData: { type: Object },

  },
  data() {
    return {
      //   批量分配
      dialogVisible: false,

      datas: {},
    };
  },
  computed: {
    y() {
      return this.personnelData.y;
    },
    g() {
      return this.personnelData.g;
    },
    p() {
      return this.personnelData.p;
    },
  },
  methods: {
    // 分配
    adjustOrderAdmin() {
      this.$api.clienteleApi.setClientAdmins(this.allotVal).then((res) => {
        this.$parent.clientList();
        this.dialogVisible = false;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-select {
  width: 100%;
}

.allot {
  margin-bottom: 10px;
}
</style>